/* tslint:disable */
/* eslint-disable */
/* @relayHash 1dd03e13fe5deb4ef3933abca2bcc439 */

import { ConcreteRequest } from "relay-runtime";
export type UploadImageInput = {
    file?: unknown | null;
    clientMutationId?: string | null;
};
export type UploadImageMutationVariables = {
    input: UploadImageInput;
};
export type UploadImageMutationResponse = {
    readonly uploadImage: {
        readonly image: {
            readonly id: string;
            readonly url: string;
        } | null;
    } | null;
};
export type UploadImageMutation = {
    readonly response: UploadImageMutationResponse;
    readonly variables: UploadImageMutationVariables;
};



/*
mutation UploadImageMutation(
  $input: UploadImageInput!
) {
  uploadImage(input: $input) {
    image {
      id
      url(size: LARGE_SQUARE)
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UploadImageInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "uploadImage",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UploadImagePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "image",
        "storageKey": null,
        "args": null,
        "concreteType": "Image",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": [
              {
                "kind": "Literal",
                "name": "size",
                "value": "LARGE_SQUARE"
              }
            ],
            "storageKey": "url(size:\"LARGE_SQUARE\")"
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UploadImageMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UploadImageMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UploadImageMutation",
    "id": null,
    "text": "mutation UploadImageMutation(\n  $input: UploadImageInput!\n) {\n  uploadImage(input: $input) {\n    image {\n      id\n      url(size: LARGE_SQUARE)\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '0e6a481ee2cb85eb263c1eaf5cbf27ce';
export default node;
